export const nameFormatter = (item: { firstName: string; lastName: string; }) => {
    if (item.firstName || item.lastName) {
        return `${item.firstName} ${item.lastName}`;
    }

    return "Saknar namn";
};
